/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import { HELPERS } from '../../helpers/index.js';
import type { UnfollowResponse, UnfollowVars } from '../openapi-types.gen.js';

export type { UnfollowResponse, UnfollowVars } from '../openapi-types.gen.js';

export const useUnfollow = createMutationHook<UnfollowVars, UnfollowResponse, unknown>({
  specName: 'useUnfollow',
  path: '/v1/users/{userId}/follows',
  method: 'DELETE',
  resolveUrl: (vars: UnfollowVars) => `/v1/users/${vars.userId}/follows`,
  
  parseResponse: (raw: unknown): UnfollowResponse => raw as UnfollowResponse,
  optimistic: [{
    queryKey: ['users', 'follow-counts'],
    apply: (prev: any, vars: UnfollowVars, queryKey: readonly unknown[], queryClient: any) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = (HELPERS.applyUnfollowCountsOptimistic as unknown as (prev: any, vars: UnfollowVars, queryKey: readonly unknown[], queryClient: any) => any)(next, vars, queryKey, queryClient);
      return next;
    },
  }],
  viewerRelationship: {"kind":"follow","targetArg":"userId","active":false} as const,
  
});
